export const COOKIES = {
  NAMES: {
    DIFFICULTY_LEVEL_ANNOTATION_COOKIE: 'difficulty_level_annotation_hide',
    REACTIVATION_BAR_COOKIE: 'reactivation_bar_hide',
    REFERRAL_CODE: 'referral_code',
    TWO_M_Benefit: '2m_benefit',
    LEAD_INFO_CLASSIFICATION: 'lead_info_classification',
    LEAD_INFO_JOURNEY: 'lead_info_journey',
    VISITOR_ID: 'visitor_id',
    ANONYMOUS_ID: 'anonymous_id',
    USER_ID: 'user_id',
    USER_SESSION: 'userSession',
  },
  EVENTS: {
    COOKIE_CONSENT_ALL: 'CookieScriptAcceptAll',
    COOKIE_CONSENT_IMPLICIT: 'CookieScriptOutsideGeoLoaded',
    PERFORMANCE_COOKIES: 'CookieScriptCategory-performance',
  },
};
